// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";
import { subTopicApi as SubTopicApi } from "../../Constant";

// Define a service using a base URL and expected endpoints
export const subTopicApi = createApi({
  reducerPath: "subTopicApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  tagTypes: ["getSubTopicList"],
  endpoints: (builder) => ({
    getSubTopicList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getSubTopicList"],
    }),

    getSingleSubTopic: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    getListData: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    deleteSubTopic: builder.mutation({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "DELETE",
      }),
      invalidatesTags: ({ success }) => {
        if (success) {
          return ["getSubTopicList"];
        }
      },
    }),

    addSubTopic: builder.mutation({
      query: ({ endpoint, newSubTopic }) => ({
        url: endpoint,
        method: "POST",
        body: newSubTopic,
      }),
      invalidatesTags: ({ success }) => {
        if (success) {
          return ["getSubTopicList"];
        }
      },
    }),

    updateSubTopic: builder.mutation({
      query: ({ endpoint, updateSubTopic }) => ({
        url: endpoint,
        method: "PATCH",
        body: updateSubTopic,
      }),
      invalidatesTags: ({ success }) => {
        if (success) {
          return ["getSubTopicList"];
        }
      },
    }),

    statusSubTopic: builder.mutation({
      query: ({ isPublished, id }) => {
        return {
          url: `${SubTopicApi.endPoint}/status/${id}`,
          method: 'PATCH',
          body: {
            isPublished
          },
        };
      },
    }),

    getSubTopicByTopic: builder.query({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "GET",
      }),
      invalidatesTags: ({ success }) => {
        if (success) {
          return ["getSubTopicList"];
        }
      },
    }),

  }),
});

export const {
  useGetSubTopicListQuery,
  useGetSingleSubTopicQuery,
  useDeleteSubTopicMutation,
  useAddSubTopicMutation,
  useUpdateSubTopicMutation,
  useGetListDataQuery,
  useStatusSubTopicMutation,
  useGetSubTopicByTopicQuery
} = subTopicApi;
